import {render} from "@testing-library/react"
import {Col, Container, Image, Row} from "react-bootstrap"
import Palette from "../utils/Palette"
import MockupImage from "../../assets/image.png"
import MockupImageAbout from "../../assets/mi-2.png"
import history5 from "../../assets/mockup_history_img_5.png"
import history2 from "../../assets/mockup_history_img_2.png"
import history3 from "../../assets/mockup_history_img_3.png"
import history4 from "../../assets/mockup_history_img_4.png"
import {Icon} from "@iconify/react"
import CustomHeading from "../reusable/CustomHeading"
import Hero from "../reusable/Hero"
import {useOutletContext} from "react-router-dom"

export default function AboutPage() {
    const [isMobile, setIsMobile, lang, setLang] = useOutletContext()
    return (
        <>
            <Hero
                title={lang.AboutPage.hero.title}
                desc={lang.AboutPage.hero.description}
            />
            <Container>
                <Row style={{
                    alignItems: 'start',
                    marginBottom: "5rem",
                    marginTop: isMobile ? "auto" : "3.75rem"
                }}>
                    <Col
                        sm={12}
                        md={8}
                        className={"d-flex flex-column justify-content-center"}
                        style={{marginBottom: "1rem"}}
                    >
                        <div style={{rowGap: "1.5rem"}}>
                            <CustomHeading text={lang.AboutPage.history.title}/>
                            <p style={{color: Palette.THEME_TEXT_MAIN}}>{lang.AboutPage.history.description}</p>
                        </div>
                    </Col>
                    <Col sm={12} md={4}>
                        <img
                            style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover"
                            }}
                            src={MockupImageAbout}
                        />
                    </Col>
                </Row>
                <Row style={{marginBottom: "5rem", marginTop: "3.75rem", rowGap: "1.5rem"}}>
                    <Col sm={12} md={6}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "0.75rem",
                                marginBottom: "1.5rem"
                            }}
                        >
							<span
                                style={{
                                    display: "flex",
                                    width: "2.5rem",
                                    height: "2.5rem",
                                    padding: "0.375rem",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "0.5rem",
                                    background: "rgba(33, 68, 116, 0.08)"
                                }}
                            >
								<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                >
									<path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.9453 5.72832C13.3583 6.08065 13.7212 6.49832 14 6.96615C14.2788 6.49832 14.6417 6.08065 15.0547 5.72832C16.0067 4.91632 17.2725 4.40765 18.5372 4.40765C19.4215 4.40765 20.3688 4.65732 21.1855 5.07965C21.9998 5.50082 22.7418 6.12382 23.1478 6.91365C23.1578 6.933 23.1668 6.95286 23.1747 6.97315L25.6597 13.5065C26.1322 14.2845 26.4233 15.1591 26.5114 16.0651C26.5996 16.9711 26.4825 17.8853 26.1688 18.7398C25.8551 19.5944 25.353 20.3673 24.6996 21.0011C24.0463 21.6349 23.2585 22.1134 22.3949 22.4011C21.5312 22.6887 20.6138 22.778 19.7109 22.6624C18.808 22.5469 17.9427 22.2294 17.1793 21.7335C16.416 21.2377 15.7741 20.5762 15.3015 19.7982C14.8288 19.0203 14.5375 18.1458 14.4492 17.2398H13.5508C13.4632 18.1465 13.1723 19.0217 12.6999 19.8005C12.2274 20.5793 11.5855 21.2416 10.8218 21.7381C10.0581 22.2346 9.19233 22.5526 8.28883 22.6684C7.38534 22.7842 6.46735 22.6949 5.60312 22.4071C4.73889 22.1193 3.95065 21.6404 3.297 21.006C2.64334 20.3716 2.14109 19.598 1.82758 18.7428C1.51406 17.8876 1.39735 16.9727 1.48613 16.0661C1.5749 15.1596 1.86687 14.2847 2.34033 13.5065L4.82533 6.97315C4.83321 6.95324 4.84217 6.93376 4.85217 6.91482C5.25933 6.12382 6.00017 5.50082 6.81333 5.07965C7.63117 4.65732 8.5785 4.40765 9.46283 4.40765C10.7275 4.40765 11.9933 4.91632 12.9453 5.72832ZM3.20833 16.6577C3.20833 15.5145 3.66245 14.4182 4.47078 13.6098C5.27911 12.8015 6.37543 12.3474 7.51858 12.3474C8.66173 12.3474 9.75806 12.8015 10.5664 13.6098C11.3747 14.4182 11.8288 15.5145 11.8288 16.6577C11.8288 17.8008 11.3747 18.8971 10.5664 19.7055C9.75806 20.5138 8.66173 20.9679 7.51858 20.9679C6.37543 20.9679 5.27911 20.5138 4.47078 19.7055C3.66245 18.8971 3.20833 17.8008 3.20833 16.6577ZM16.1712 16.6577C16.1712 15.5145 16.6253 14.4182 17.4336 13.6098C18.2419 12.8015 19.3383 12.3474 20.4814 12.3474C21.6246 12.3474 22.7209 12.8015 23.5292 13.6098C24.3376 14.4182 24.7917 15.5145 24.7917 16.6577C24.7917 17.8008 24.3376 18.8971 23.5292 19.7055C22.7209 20.5138 21.6246 20.9679 20.4814 20.9679C19.3383 20.9679 18.2419 20.5138 17.4336 19.7055C16.6253 18.8971 16.1712 17.8008 16.1712 16.6577Z"
                                        fill="#214474"
                                    />
								</svg>
							</span>
                            <div
                                style={{
                                    fontSize: "1.75rem",
                                    fontWeight: 700,
                                    lineHeight: "2.25rem"
                                }}
                            >{lang.AboutPage.visionMission.vision.title}</div>
                        </div>
                        <p>{lang.AboutPage.visionMission.vision.description}</p>
                    </Col>
                    <Col sm={12} md={6}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "0.75rem",
                                marginBottom: "1.5rem"
                            }}
                        >
							<span
                                style={{
                                    display: "flex",
                                    width: "2.5rem",
                                    height: "2.5rem",
                                    padding: "0.375rem",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "0.5rem",
                                    background: "rgba(33, 68, 116, 0.08)"
                                }}
                            >
								<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                >
									<path
                                        d="M13.9999 25.6666C12.386 25.6666 10.8694 25.3602 9.44992 24.7473C8.03047 24.1344 6.79575 23.3034 5.74575 22.2541C4.69575 21.2041 3.8647 19.9694 3.25259 18.55C2.64047 17.1305 2.33403 15.6139 2.33325 14C2.33325 12.3861 2.6397 10.8694 3.25259 9.44998C3.86547 8.03054 4.69653 6.79581 5.74575 5.74581C6.79575 4.69581 8.03047 3.86476 9.44992 3.25265C10.8694 2.64054 12.386 2.33409 13.9999 2.33331C15.6138 2.33331 17.1305 2.63976 18.5499 3.25265C19.9694 3.86554 21.2041 4.69659 22.2541 5.74581C23.3041 6.79581 24.1355 8.03054 24.7484 9.44998C25.3613 10.8694 25.6674 12.3861 25.6666 14C25.6666 15.6139 25.3601 17.1305 24.7473 18.55C24.1344 19.9694 23.3033 21.2041 22.2541 22.2541C21.2041 23.3041 19.9694 24.1356 18.5499 24.7485C17.1305 25.3614 15.6138 25.6674 13.9999 25.6666ZM13.9999 23.3333C16.6055 23.3333 18.8124 22.4291 20.6208 20.6208C22.4291 18.8125 23.3333 16.6055 23.3333 14C23.3333 11.3944 22.4291 9.18748 20.6208 7.37915C18.8124 5.57081 16.6055 4.66665 13.9999 4.66665C11.3944 4.66665 9.18742 5.57081 7.37909 7.37915C5.57075 9.18748 4.66659 11.3944 4.66659 14C4.66659 16.6055 5.57075 18.8125 7.37909 20.6208C9.18742 22.4291 11.3944 23.3333 13.9999 23.3333ZM13.9999 21C12.0555 21 10.4027 20.3194 9.04158 18.9583C7.68047 17.5972 6.99992 15.9444 6.99992 14C6.99992 12.0555 7.68047 10.4028 9.04158 9.04165C10.4027 7.68053 12.0555 6.99998 13.9999 6.99998C15.9444 6.99998 17.5971 7.68053 18.9583 9.04165C20.3194 10.4028 20.9999 12.0555 20.9999 14C20.9999 15.9444 20.3194 17.5972 18.9583 18.9583C17.5971 20.3194 15.9444 21 13.9999 21ZM13.9999 18.6666C15.2833 18.6666 16.3819 18.2097 17.2958 17.2958C18.2096 16.3819 18.6666 15.2833 18.6666 14C18.6666 12.7166 18.2096 11.618 17.2958 10.7041C16.3819 9.79026 15.2833 9.33331 13.9999 9.33331C12.7166 9.33331 11.618 9.79026 10.7041 10.7041C9.7902 11.618 9.33325 12.7166 9.33325 14C9.33325 15.2833 9.7902 16.3819 10.7041 17.2958C11.618 18.2097 12.7166 18.6666 13.9999 18.6666ZM13.9999 16.3333C13.3583 16.3333 12.8088 16.1046 12.3514 15.6473C11.8941 15.19 11.6658 14.6409 11.6666 14C11.6666 13.3583 11.8953 12.8088 12.3526 12.3515C12.8099 11.8941 13.359 11.6659 13.9999 11.6666C14.6416 11.6666 15.1911 11.8953 15.6484 12.3526C16.1058 12.81 16.334 13.3591 16.3333 14C16.3333 14.6416 16.1046 15.1911 15.6473 15.6485C15.1899 16.1058 14.6408 16.3341 13.9999 16.3333Z"
                                        fill="#214474"
                                    />
								</svg>
							</span>
                            <div
                                style={{
                                    fontSize: "1.75rem",
                                    fontWeight: 700,
                                    lineHeight: "2.25rem"
                                }}
                            >{lang.AboutPage.visionMission.mission.title}</div>
                        </div>
                        <p>{lang.AboutPage.visionMission.mission.description}</p>
                    </Col>
                </Row>
            </Container>
            <Row>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1440"
                    height="60"
                    viewBox="0 0 1440 60"
                    fill="none"
                    preserveAspectRatio="none"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0 32.8545L39.6 27.1991C80.4 21.5438 159.6 10.2332 240 4.57784C320.4 -1.07748 399.6 -1.07748 480 2.31571C560.4 5.70891 639.6 12.4953 720 11.3642C800.4 10.2332 879.6 1.18465 960 6.83997C1040.4 12.4953 1119.6 32.8545 1200 36.2477C1280.4 39.6408 1359.6 26.0681 1400.4 19.2817L1440 12.4953V60H1400.4C1359.6 60 1280.4 60 1200 60C1119.6 60 1040.4 60 960 60C879.6 60 800.4 60 720 60C639.6 60 560.4 60 480 60C399.6 60 320.4 60 240 60C159.6 60 80.4 60 39.6 60H0V32.8545Z"
                        fill="#F7F7F8"
                    />
                </svg>
            </Row>

        </>
    )
}
